module.exports = __webpack_public_path__ + "img/goal2.c574a306.svg";